"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9219],{

/***/ 39219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ subcategory; }
});

// UNUSED EXPORTS: getServerSideProps

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ./src/containers/default/getServerSideProps.js
var getServerSideProps = __webpack_require__(5349);
// EXTERNAL MODULE: ./src/containers/default/page.js + 16 modules
var page = __webpack_require__(25442);
// EXTERNAL MODULE: ./src/utils/withCustomError.js
var withCustomError = __webpack_require__(54026);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../modules/build/esm/novisual/GoogleTagManagerNoscript/index.js
var GoogleTagManagerNoscript = __webpack_require__(59462);
// EXTERNAL MODULE: ../modules/build/esm/novisual/ApssFlyerBanner/index.js
var ApssFlyerBanner = __webpack_require__(33636);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/index.js + 5 modules
var AdsBanner = __webpack_require__(10369);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ExternalContent/index.js + 3 modules
var ExternalContent = __webpack_require__(41593);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Header/index.js + 3 modules
var Header = __webpack_require__(54578);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Breadcrumb/index.js + 2 modules
var Breadcrumb = __webpack_require__(32060);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ToolBar/index.js + 2 modules
var ToolBar = __webpack_require__(10492);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/index.js + 20 modules
var AdsBrand = __webpack_require__(70989);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Heading/index.js + 1 modules
var Heading = __webpack_require__(89940);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductList/index.js
var ProductList = __webpack_require__(28981);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Pagination/index.js + 1 modules
var Pagination = __webpack_require__(9401);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Faq/index.js + 1 modules
var Faq = __webpack_require__(67546);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/TermList/index.js + 1 modules
var TermList = __webpack_require__(98898);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SeoCategoryTreeLinks/index.js + 8 modules
var SeoCategoryTreeLinks = __webpack_require__(48903);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/LuContent/index.js + 2 modules
var LuContent = __webpack_require__(7905);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/DocumentSupportText/index.js + 2 modules
var DocumentSupportText = __webpack_require__(87066);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SeoLinkList/index.js + 2 modules
var SeoLinkList = __webpack_require__(66646);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Footer/index.js + 1 modules
var Footer = __webpack_require__(16447);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Favicon/index.js
var Favicon = __webpack_require__(80995);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Preconnect/index.js
var Preconnect = __webpack_require__(42438);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Preload/index.js
var Preload = __webpack_require__(31316);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Datadog/index.js
var Datadog = __webpack_require__(64002);
// EXTERNAL MODULE: ../modules/build/esm/novisual/GoogleTagManagerHead/index.js
var GoogleTagManagerHead = __webpack_require__(14499);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Stewie/index.js
var Stewie = __webpack_require__(48517);
// EXTERNAL MODULE: ../modules/build/esm/novisual/AllIn/index.js
var AllIn = __webpack_require__(82896);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Criteo/index.js
var Criteo = __webpack_require__(63760);
// EXTERNAL MODULE: ../modules/build/esm/novisual/TikTok/index.js
var TikTok = __webpack_require__(62300);
// EXTERNAL MODULE: ../modules/build/esm/novisual/SpotifyAdAnalytics/index.js
var SpotifyAdAnalytics = __webpack_require__(66775);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Hotjar/index.js
var Hotjar = __webpack_require__(61220);
// EXTERNAL MODULE: ../modules/build/esm/novisual/RTBHouse/index.js
var RTBHouse = __webpack_require__(50682);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Vwo/index.js + 1 modules
var Vwo = __webpack_require__(2159);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Azion/index.js
var Azion = __webpack_require__(14286);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Bing/index.js
var Bing = __webpack_require__(94842);
;// CONCATENATED MODULE: ./src/containers/subcategory/pageModules.js
/* eslint-disable */ 

































var pageModules = {
    GoogleTagManagerNoscript: GoogleTagManagerNoscript/* default */.Z,
    ApssFlyerBanner: ApssFlyerBanner/* default */.Z,
    AdsBanner: AdsBanner/* default */.ZP,
    ExternalContent: ExternalContent/* default */.Z,
    Header: Header/* default */.Z,
    Breadcrumb: Breadcrumb/* default */.Z,
    ToolBar: ToolBar/* default */.Z,
    AdsBrand: AdsBrand/* default */.ZP,
    Heading: Heading/* default */.Z,
    ProductList: ProductList/* default */.Z,
    Pagination: Pagination/* default */.Z,
    Faq: Faq/* default */.Z,
    TermList: TermList/* default */.Z,
    SeoCategoryTreeLinks: SeoCategoryTreeLinks/* default */.Z,
    LuContent: LuContent/* default */.Z,
    DocumentSupportText: DocumentSupportText/* default */.Z,
    SeoLinkList: SeoLinkList/* default */.Z,
    Footer: Footer/* default */.Z,
    Favicon: Favicon/* default */.Z,
    Preconnect: Preconnect/* default */.Z,
    Preload: Preload/* default */.Z,
    Datadog: Datadog/* default */.Z,
    GoogleTagManagerHead: GoogleTagManagerHead/* default */.Z,
    Stewie: Stewie/* default */.Z,
    AllIn: AllIn/* default */.Z,
    Criteo: Criteo/* default */.Z,
    TikTok: TikTok/* default */.Z,
    SpotifyAdAnalytics: SpotifyAdAnalytics/* default */.Z,
    Hotjar: Hotjar/* default */.Z,
    RTBHouse: RTBHouse/* default */.Z,
    Vwo: Vwo/* default */.Z,
    Azion: Azion/* default */.Z,
    Bing: Bing/* default */.Z,
    BackToTop: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51658));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(51658)
                ];
            }
        },
        ssr: false
    }),
    CloseableAdUnit: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 28487));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(28487)
                ];
            }
        },
        ssr: false
    }),
    ZipCodeBar: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 199));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(199)
                ];
            }
        },
        ssr: false
    }),
    ZipCodeInput: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 40261));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(40261)
                ];
            }
        },
        ssr: false
    }),
    FilterDelivery: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 20958));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(20958)
                ];
            }
        },
        ssr: false
    }),
    Loader: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79331));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(79331)
                ];
            }
        },
        ssr: false
    })
};
/* harmony default export */ var subcategory_pageModules = (pageModules);

;// CONCATENATED MODULE: ./src/containers/subcategory/pageConfig.json
var pageConfig_namespaceObject = JSON.parse('{"routeAlias":{"path0":"subCategorySlug","path1":"categorySlug","path3":"categoryId","path4":"subCategoryId","path5":"filters"},"routeId":"subcategory","routePath":"/:subCategorySlug/:categorySlug/s/:categoryId/:subCategoryId/:?filters/","siteId":"magazineluiza-mobile"}');
;// CONCATENATED MODULE: ./src/containers/subcategory/index.js










var _routeAlias = pageConfig_namespaceObject.routeAlias, routeAlias = _routeAlias === void 0 ? {} : _routeAlias, config = (0,_object_without_properties/* default */.Z)(pageConfig_namespaceObject, [
    "routeAlias"
]);
var Subcategory = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        modules: subcategory_pageModules
    }));
};
var subcategory_getServerSideProps = function() {
    var ctx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    var resolvedUrl = ((ref1 = (ref = ctx.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0]) || pageConfig.routePath;
    var query = objectRemoveMatchedKey(ctx.query || {}, routeAlias);
    var params = objectConvertAlias(ctx.params || {}, routeAlias);
    return defaultGetServerSideProps(_object_spread_props(_object_spread({}, ctx, config), {
        params: params,
        query: query,
        resolvedUrl: resolvedUrl
    }));
};
/* harmony default export */ var subcategory = ((0,withCustomError/* default */.Z)(Subcategory));


/***/ }),

/***/ 54026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70689);
/* eslint-disable react/prop-types */ /* eslint-disable react/display-name */ /* eslint-disable import/no-unresolved */ 



var Custom404 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7975).then(__webpack_require__.bind(__webpack_require__, 47975)).catch(function() {
        return null;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47975)
            ];
        }
    }
});
var withCustomError = function(Page) {
    var CustomErrorPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Custom404;
    return function(props) {
        var _structure = props.structure, structure = _structure === void 0 ? {} : _structure, errorCode = props.errorCode, errorTitle = props.errorTitle;
        if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
            statusCode: errorCode,
            title: errorTitle
        });
        if (CustomErrorPage && structure.id && structure.id === "404") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomErrorPage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withCustomError);


/***/ })

}]);